module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [(_vm.segment == null) ? _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]) : _c('a', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), (_vm.segment == null) ? _c('h2', [_vm._v("Create new segment")]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.segment === null) ? [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })])] : [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.segment._translatable.name,
      "label": "Name",
      "value": _vm.segment.name
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })])], _c('label', [_vm._v("Picture"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.picture),
      expression: "body.picture"
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.body.picture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "picture", $event.target.value)
      }
    }
  })]), _c('kepler-file-upload', {
    attrs: {
      "selectedPrefix": "segments",
      "selectedVisibility": "public"
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  })], 2), _c('div', {
    staticClass: "column"
  }, [(_vm.segment === null) ? [_c('label', [_vm._v("Hint"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.hint),
      expression: "body.hint"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.hint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "hint", $event.target.value)
      }
    }
  })])] : [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.segment._translatable.hint,
      "label": "Hint",
      "value": _vm.segment.hint
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.hint),
      expression: "body.hint"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.hint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "hint", $event.target.value)
      }
    }
  })])]], 2)]), _c('div', {
    staticClass: "row column"
  }, [(_vm.segment === null) ? [_c('label', [_vm._v("Description")])] : [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.segment._translatable.description,
      "label": "Description",
      "value": _vm.segment.description,
      "editor": true
    }
  })], _c('Editor', {
    model: {
      value: (_vm.body.description),
      callback: function($$v) {
        _vm.$set(_vm.body, "description", $$v)
      },
      expression: "body.description"
    }
  })], 2), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f7d52b4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/SegmentReveal.vue
// module id = 2434
// module chunks = 1